import React from 'react';

function ExpandedIcon() {
    return (
        <>
            <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.01172 1L6.31684 5.92507C6.42445 6.02498 6.59899 6.02498 6.7066 5.92507L12.0117 1" stroke="#ACACAC" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        </>
    );
}

export default ExpandedIcon;